export const LIMPAR_FILTROS_LABEL = "Limpar Filtros";

export const FILTRO_CARREGANDO_MESSAGE = "Carregando opções...";
export const FILTRO_ERRO_MESSAGE = "Não foi possível carregar as opções.";
export const FILTRO_VAZIO_MESSAGE = "Nenhuma opção disponível.";
export const FILTRO_SEM_RESULTADO_MESSAGE = "Nenhuma opção encontrada.";

/** Limite do contrato do bff e do core por filtro de múltiplos valores. */
export const FILTRO_MAX_ITENS = 50;
